import type { CountryCode } from "@/config/country-config";

// FLOW's enum also has FlexibleMortgage, FlexibleConsumerLoan, ChargeCard,
// HousingCooperativeSharedDebt and Other; unlabelled here, a fetched one shows its raw type.
export const DEBT_TYPES = [
	"ConsumerLoan",
	"Creditcard",
	"MortgageLoan",
	"VehicleLoan",
	"StudentLoan",
] as const;

export type DebtType = (typeof DEBT_TYPES)[number];

export const DEBT_TYPES_BY_COUNTRY: Record<CountryCode, readonly DebtType[]> = {
	SE: ["ConsumerLoan", "Creditcard", "VehicleLoan", "MortgageLoan"],
	FI: ["MortgageLoan", "VehicleLoan", "StudentLoan", "ConsumerLoan"],
	// Mirrors SE until the Norwegian specification arrives.
	NO: ["ConsumerLoan", "Creditcard", "VehicleLoan", "MortgageLoan"],
};

export const isDebtType = (value: unknown): value is DebtType =>
	typeof value === "string" &&
	(DEBT_TYPES as readonly string[]).includes(value);

// FLOW passes the credit check's own wording, which is unlocalised in Finland.
const DEBT_TYPE_BY_CREDIT_CHECK_DESCRIPTION: Record<string, DebtType> = {
	"consumer credit": "ConsumerLoan",
};

export const debtTypeFromCreditCheckDescription = (
	raw: string | undefined
): DebtType | undefined =>
	DEBT_TYPE_BY_CREDIT_CHECK_DESCRIPTION[raw?.trim().toLowerCase() ?? ""];
